<template>
  <div
    class="c-virtual-list__row"
    :class="{ 'is-checked': isChecked }"
    @click.prevent="click"
  >
    <div class="c-virtual-list__col check">
      <Checkbox
        :id="type + '_' + item.id"
        :name="type + '[]'"
        :value="item"
        :checked="checked"
        ref="checkbox"
        @change="change"
      />
    </div>
    <template v-if="isChangeTd || isRewrite">
      <div class="c-virtual-list__col keyword">
        <EllipsisPopover placement="right-end">
          {{ item.keyword }}
        </EllipsisPopover>
      </div>
      <div class="c-virtual-list__col rank c-text--right">
        {{ item.rank | roundFloatingPointNumber(1) }}
      </div>
      <div class="c-virtual-list__col searchVolume c-text--right">
        {{ item.searchVolume | separateNumber | truncateNull }}
      </div>
      <div class="c-virtual-list__col impressions c-text--right">
        {{ item.impressions | separateNumber | nullToZero }}
      </div>
      <div class="c-virtual-list__col ctr c-text--right">
        {{ (item.ctr * 100) | roundFloatingPointNumber(2) }}%
      </div>
      <div class="c-virtual-list__col influx c-text--right">
        {{ item.influx | separateNumber | nullToZero }}
      </div>
      <div class="c-virtual-list__col url">
        <EllipsisPopover placement="left-end">
          <a :href="item.url" target="_blank" class="c-link--blank" @click.stop>
            {{ item.url | removeDomain(project.siteUrl) }}
          </a>
          <template slot="popover">
            <a :href="item.url" target="_blank" @click.stop>
              {{ item.url | removeDomain(project.siteUrl) }}
            </a>
          </template>
        </EllipsisPopover>
      </div>
      <div class="c-virtual-list__col title">
        <EllipsisPopover placement="left-end">
          {{ item.title }}
        </EllipsisPopover>
      </div>
    </template>
    <template v-else-if="isCreateContent">
      <div class="c-virtual-list__col keyword">
        <EllipsisPopover placement="right-end">
          {{ item.keyword }}
        </EllipsisPopover>
      </div>
      <div class="c-virtual-list__col rank c-text--right">
        <template v-if="item.rank === 9999">
          圏外
        </template>
        <template v-else>
          {{ item.rank | roundFloatingPointNumber(1) }}
        </template>
      </div>
      <div class="c-virtual-list__col searchVolume c-text--right">
        {{ item.searchVolume | separateNumber | truncateNull }}
      </div>
      <div class="c-virtual-list__col url">
        <EllipsisPopover
          v-if="item.url !== null && item.url !== ''"
          placement="left-end"
        >
          <a :href="item.url" target="_blank" class="c-link--blank" @click.stop>
            {{ item.url | removeDomain(project.siteUrl) }}
          </a>
          <template slot="popover">
            <a :href="item.url" target="_blank" @click.stop>
              {{ item.url | removeDomain(project.siteUrl) }}
            </a>
          </template>
        </EllipsisPopover>
        <template v-else>
          -
        </template>
      </div>
      <div class="c-virtual-list__col title">
        <EllipsisPopover
          v-if="item.title !== null && item.title !== ''"
          placement="left-end"
        >
          {{ item.title }}
        </EllipsisPopover>
        <template v-else>
          -
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import EllipsisPopover from '@/components/EllipsisPopover';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Checkbox,
    EllipsisPopover
  },
  computed: {
    isChecked() {
      return this.checked.includes(this.item);
    },
    isCreateContent() {
      return this.type === 'createContent';
    },
    isChangeTd() {
      return this.type === 'changeTd';
    },
    isRewrite() {
      return this.type === 'rewrite';
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    },
    click() {
      this.$refs.checkbox.change();
    }
  }
};
</script>
